import * as React from 'react';

import { 
  GlobalPrivateState, 
  QueryParemeterPayload, 
  addFilterParam,
  FilterFormModel,
  QuerySearchFilterForm,
  InputModel,
} from '../../../../../api';

import classNames from 'classnames';

import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';
import { remove as _remove } from 'lodash';

import './../TroughFilter.scss';

type FilterFormData = FilterFormModel;

export interface TroughFilterAndProps {
  dispatch: any;
  fields: FilterFormData;
  params: QueryParemeterPayload;
  queryKey: 'form';
}

export interface ThroughFilterAndState {
  formFields?: FilterFormData;
  filter?: QueryParemeterPayload;
}

export class TroughFilterAndPartial extends React.Component<TroughFilterAndProps, ThroughFilterAndState> {
  
  constructor(props: TroughFilterAndProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      formFields: props.fields,
    };
  }
  
  public render() {
    const {
      formFields,
    } = this.state;
    
    return (
      <>
        {formFields && Object.keys(formFields).map((fieldKey: string, index: number) => {
          const key = `form_field_${fieldKey}_${index}`;
          const field: InputModel & {checked: boolean} = formFields[fieldKey];
          const checked = this.isChecked(field.value as QuerySearchFilterForm);
          return (
            <div key={key} className="filter-btns">
              <div className="position-relative position-relative form-group">
                <label htmlFor={key} className="font-weight-bold small">
                  <span className={classNames('field-label', {'active': checked})}>
                    {field.label}
                  </span>
                  <input 
                    className="form-control border-top-0 border-left-0 border-right-0 p-0" 
                    id={key} 
                    name={field.name} 
                    onChange={this.handleChange}
                    type="checkbox" 
                    value={field.value as string}
                    checked={checked}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            </div>
          );
        })}
      </>
    );
  }

  private isChecked(name: QuerySearchFilterForm): boolean {
    if (this.formFilter.indexOf(name) > -1) {
      return true;
    }
    return false;
  }

  // private activate(fields: FilterFormData, form?: QuerySearchFilterForm[]): FilterFormData {
  //   const formFilter = form || this.formFilter;
  //   const newFields = fields;
  //   Object.keys(newFields).map(key => {
  //     const field: InputModel & {checked: boolean} = newFields[key];
  //     if ((formFilter as any).indexOf(field.value) > -1) {
  //       newFields[key].checked = true;
  //     } else {
  //       newFields[key].checked = false;
  //     }
  //   });
  //   return newFields;
  // }

  private get filter(): QueryParemeterPayload['filter'] | undefined {
    return this.props.params && this.props.params.filter;
  }

  private get formFilter(): QuerySearchFilterForm[] {
    return this.filter && this.filter.form || [];
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) { 
    let filter: QueryParemeterPayload | {} = this.filter || {};
    const formFilter: QuerySearchFilterForm[] = this.formFilter;
    // const fields = this.state.formFields;
    const target = event.target as HTMLInputElement;
    const value = target.value as QuerySearchFilterForm;
    const indexOfValue = formFilter.indexOf(value);
    
    if (indexOfValue > -1) {
      formFilter.splice(indexOfValue, 1);
    } else {
      formFilter.push(value);
    }

    if (filter) {
      filter = _assign({}, {form: formFilter.length > 0 ? formFilter : undefined});
    }

    this.props.dispatch(addFilterParam(filter));

    // this.setState({
    //   formFields: fields && this.activate(fields, formFilter),
    // });
  }
}

export const TroughFilterFormAnd = connect((state: GlobalPrivateState) => ({
  params: state.queryState.params,
}))(TroughFilterAndPartial);

export default TroughFilterFormAnd;